import MediaCenterCards from "./MediaCenterCards"
import { IMediaCenterProps } from "./types"

interface MediaCenterEventsProps {
  data: IMediaCenterProps[]
  cardsToShow: number
  setActiveModal: (value: boolean) => void
  setModalData: (data: IMediaCenterProps | null) => void
  optimizedImage?: boolean
}

const MediaCenterEvents = ({
  data,
  cardsToShow,
  setActiveModal,
  setModalData,
  optimizedImage,
}: MediaCenterEventsProps) => {

  return (
    <div className="mediaCenterEvents ">
      <div className="media-events ">
        <div className="active_cards grid grid-cols-1 md:grid-cols-2 w-full gap-8">
          {data.slice(0, 2).map((item, index) => {
            return <MediaCenterCards
              key={`media-center-top-${item.id}`}
              data={item}
              twoCards
              isOne={index == 1}
              setActiveModal={setActiveModal}
              setModalData={setModalData}
              optimizedImage={optimizedImage}
            />
          })}
        </div>
        <div className="cards grid grid-cols-1 lg:grid-cols-3 w-full gap-x-8">
          {data.slice(2, cardsToShow).map((item, index) => (
            <MediaCenterCards
              key={`media-center-bottom-${item.id}`}
              data={item}
              isSecondInRow={index % 2 === 1}
              setActiveModal={setActiveModal}
              setModalData={setModalData}
              optimizedImage={optimizedImage}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default MediaCenterEvents
